import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import BenefitsView from './BenefitsView'
import HomeView from './HomeView'
import UseEligibility from './UseEligibility'
import { useReactToPrint } from 'react-to-print'
import { useSelector } from 'react-redux'
import { TODAY_DATE } from 'Common/Constants'
import moment from "moment-mini"
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'


const EligibilityLogDetail = forwardRef(({ eligibilityData, onOpenCoPaymentPopup, patientId }, ref) => {
    const [outlinesOpen, setOutlinesOpen] = useState(true)
    const [handleClick, visibleItemId, distinctBenifits, arrr, itemsRef] = UseEligibility(eligibilityData)
    const { userinfo, practiceDetails } = useSelector((state) => state.userAuth);
    const contentToPrint = useRef(null);
    useImperativeHandle(ref, () => {
        return {
            handlePrintPKG,
            printContent: () => contentToPrint.current
        };
    });

    const handlePrintPKG = useReactToPrint({
        documentTitle: "Eligibility Log",
        removeAfterPrint: false,
    });

    return (
        <div className='bg-[#F6F8FA] pt-4 pb-4 px-2'>
            <div className='flex gap-2'>
                {/* Toggle icon when closed; full Outlines panel when open */}
                {outlinesOpen ? (
                    <div className='flex-shrink-0 overflow-auto bg-white rounded-md max-h-96 flex flex-col w-[33.333%] min-w-[200px]'>
                        <div className='flex items-center justify-between px-3 py-2 border-b border-slate-200 bg-slate-50 rounded-t-md'>
                            <span className='font-medium text-gray-700'>Outlines</span>
                            <button
                                type='button'
                                onClick={() => setOutlinesOpen(false)}
                                className='p-1 rounded hover:bg-slate-200 text-slate-600 cursor-pointer'
                                title='Hide outlines'
                                aria-label='Hide outline menu'
                            >
                                <FiChevronLeft className='w-4 h-4' />
                            </button>
                        </div>
                        <ul className='px-2 py-4 flex-1 overflow-auto'>
                            <li onClick={() => handleClick({ benefitDescription: "home" })} className={`${visibleItemId === "home" ? "text-secondary font-medium" : "text-secondaryLight"} px-3 pb-2 mb-3 border-b cursor-pointer`} title="Home">Home</li>
                            {distinctBenifits.map((log) => (
                                <li key={log.id} onClick={() => handleClick(log)} className={`${visibleItemId === log.benefitDescription ? "text-secondary font-medium" : "text-secondaryLight"} px-3 pb-2 mb-3 border-b cursor-pointer`} title={`${log.benefitCode} - ${log.benefitDescription}`}>
                                    {log.benefitDescription ? `${log.benefitCode} - ${log.benefitDescription}` : (log.benefitCode || '')}
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <div className='flex-shrink-0 flex items-stretch'>
                        <button
                            type='button'
                            onClick={() => setOutlinesOpen(true)}
                            className='w-11 min-h-[12rem] max-h-96 flex flex-col items-center justify-center rounded-l-lg border border-r-0 border-slate-200 bg-white shadow-sm hover:bg-slate-50 hover:border-slate-300 hover:shadow text-slate-500 hover:text-secondary transition-all cursor-pointer group'
                            title='Show outlines'
                            aria-label='Show outline menu'
                        >
                            <FiChevronRight className='w-5 h-5 flex-shrink-0 group-hover:translate-x-0.5 transition-transform' />
                        </button>
                    </div>
                )}
                <div id="printHomeView" ref={contentToPrint} className={`p-5 overflow-auto bg-white scroll-container max-h-96 flex-1 min-w-0 ${outlinesOpen ? 'rounded-md' : 'rounded-r-md rounded-l-none border border-slate-200 border-l-0 shadow-sm'}`}>
                    <ul>
                        {arrr.map((benefit, i) => {
                            if (benefit.benefitDescription === "home") {
                                return (<li ref={(el) => (itemsRef.current[i] = el)} id={benefit.benefitDescription} >
                                    <HomeView subscriberInformation={benefit} eligibilityData={eligibilityData} />
                                </li>)
                            }
                            else {
                                let [key] = Object.entries(benefit)

                                return <li className='relative mb-5 '>
                                    <span ref={(el) => (itemsRef.current[i] = el)} id={key[0]} className='bg-none  pointer-events-none h-[200px] w-full absolute top-0'></span>
                                    <BenefitsView
                                    key={key[0]}
                                    name={key[0]}
                                    benefit={key[1]}
                                    onCoPaymentClick={(benefit) => {
                                        const amount = benefit?.benefitAmount ?? 0;
                                        const serviceDate = eligibilityData?.eligibilityDate?.split?.('T')?.[0] ?? '';
                                        onOpenCoPaymentPopup?.({ patientId, amount, serviceDate });
                                    }}
                                />
                                </li>
                            }
                        })}
                    </ul>
                    <div className='justify-between hidden mt-4 font-semibold print:flex'>
                        <p>Downloaded By : {userinfo.userName}</p>
                        <p>Date : {moment(TODAY_DATE).format("MM/DD/YYYY")}</p>
                        <p>Practice : {practiceDetails.name}</p>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default EligibilityLogDetail